/**
 * Detect the nearest ancestor's non-transparent background color.
 * Walks up the DOM tree from the given element until it finds a visible background.
 *
 * @param {HTMLElement} element - Starting element
 * @returns {string|null} Background color (e.g., "rgb(243, 244, 246)") or null
 */
export function detectAncestorBackground(element) {
    let current = element;
    while (current && current !== document.documentElement) {
        const bg = getComputedStyle(current).backgroundColor;
        if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') {
            return bg;
        }
        current = current.parentElement;
    }
    return null;
}
